/** parseDataSubmissionFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseDataSubmissionFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  status: params.get("status"),
  id_cnts: params.get("id_ctns"),
  destination: params.get("destination"),
  label_cnts: params.get("label_cnts"),
  observation_id: params.get("observation_id"),
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "created_at", // The column to sort by
})
